/**
 * Subscribe & Save volume discount helpers — mirrors
 * abc-discounts-2025 subscribe-and-save-discount-3-0 cart_lines_discounts_generate_run.js
 */
const FLAGSHIP_BEER_UNIT_PRICE_CENTS = 1099;

function getVolumeDiscountPercentage(bundleSize) {
  if (bundleSize >= 5) return 0.15;
  if (bundleSize >= 4) return 0.1;
  if (bundleSize >= 3) return 0.05;
  return 0;
}

function isDiscountExcludedByPrice(priceCents) {
  return parseFloat(priceCents) === FLAGSHIP_BEER_UNIT_PRICE_CENTS;
}

function hasDiscountExcludeTag(product) {
  const tags = product?.tags || [];
  return tags.some((tag) => tag.toLowerCase() === 'discountexclude');
}

function isLineEligibleForVolumeDiscount(product) {
  const priceCents = parseFloat(product?.price);
  return !hasDiscountExcludeTag(product) && !isDiscountExcludedByPrice(priceCents);
}

function calculateVolumeDiscountedTotal(products, bundleSize) {
  const discountPct = getVolumeDiscountPercentage(bundleSize);

  return products.reduce((sum, product) => {
    const price = parseFloat(product.price);
    if (isNaN(price)) return sum;

    if (discountPct > 0 && isLineEligibleForVolumeDiscount(product)) {
      return sum + price * (1 - discountPct);
    }

    return sum + price;
  }, 0);
}

function calculateLineDiscountedPrice(product, bundleSize, options = {}) {
  const { clubMembershipToggleOn = false, clubPrice = 0 } = options;
  const originalPrice = parseFloat(product.price);
  if (isNaN(originalPrice)) return null;

  if (clubMembershipToggleOn && bundleSize > 3 && clubPrice > 0) {
    return clubPrice;
  }

  const discountPct = getVolumeDiscountPercentage(bundleSize);
  if (discountPct > 0 && isLineEligibleForVolumeDiscount(product)) {
    return originalPrice * (1 - discountPct);
  }

  return null;
}

function hasEligibleDiscountedLines(products, bundleSize) {
  const discountPct = getVolumeDiscountPercentage(bundleSize);
  if (discountPct === 0) return false;

  return products.some((product) => isLineEligibleForVolumeDiscount(product));
}

window.__abc = window.__abc || {};
window.__abc.subscriptionDiscount = {
  FLAGSHIP_BEER_UNIT_PRICE_CENTS,
  getVolumeDiscountPercentage,
  isDiscountExcludedByPrice,
  hasDiscountExcludeTag,
  isLineEligibleForVolumeDiscount,
  calculateVolumeDiscountedTotal,
  calculateLineDiscountedPrice,
  hasEligibleDiscountedLines,
};
